import { createTCMSchedule, TCMScheduleVersion } from "@nt-portal/tcm-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { TCMScheduleVersionService } from '@nt-portal/tcm-sdk/dist/services/tcm/schedule/schedule-version.service'
import { FileData, ResultData } from "@nt-portal/common-sdk";

export interface TCMScheduleVersionOptions extends ControllerOptions<TCMScheduleVersion> {
    versionNumber?: number;
}

export const createTCMScheduleVersion = (obj: Partial<TCMScheduleVersion>) => {
    let item: TCMScheduleVersion = {
        schedule: obj.schedule ?? createTCMSchedule({}),
        versionNumber: 0,
        createdBy: "",
        createdDate: undefined,
        fileName: ""
    }
    return item;
}


export class ClientTCMScheduleVersionService extends BaseClientService implements DataController<TCMScheduleVersion> {

    private _service: TCMScheduleVersionService;


    constructor() {
        super();
        this._service = new TCMScheduleVersionService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public set params(params: any) {
        this._service.params = params;
    }

    public get params() {
        return this._service.params ?? {};
    }

    public async get(options: TCMScheduleVersionOptions): Promise<ResultData<TCMScheduleVersion>> {

        return await this._service.get(this.buildFetchParams(options), this.token, options.filter);

    }

    public async template(options: TCMScheduleVersionOptions): Promise<FileData | null> {
        if (options.versionNumber)
            return await this._service.template(this.token, options.versionNumber)
        return null;
    }

    public async last(): Promise<TCMScheduleVersion> {
        return await this._service.lastVersion(this.token);
    }

    public async getLookup(options: TCMScheduleVersionOptions): Promise<ResultData<TCMScheduleVersion>> {
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token);
        return data;
    }

    public async getById(options: TCMScheduleVersionOptions): Promise<TCMScheduleVersion | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }


}